import { useEffect, useState } from "react";
import { ImSpinner2 } from "react-icons/im";
import styled from "styled-components";
import ErrorAlert from "../alerts/ErrorAlert";
import WarnAlert from "../alerts/WarnAlert";

const Main = styled.div`
    width: 100%;
    align-items: center;
    display: flex;
    align-content: center;
    justify-content: center;
    flex-direction: column;
`

const StyledSpinner = styled(ImSpinner2)`
    height: 32px;
    width: 32px;
    rotate: 0deg;
    animation: spinnerspin 1s infinite linear;
    @media (prefers-color-scheme: dark) {
        color: var(--bs-gray-100);
    }

    @keyframes spinnerspin {
        from {transform:rotate(0deg);}
        to {transform:rotate(359deg);}
    }
`;

const Loading = () => {
    const [state, setState] = useState(0);

    useEffect(() => {
        let ctr = 0;
        const interval = setInterval(() => {
            ctr++;
            if (ctr > 3) { setState(1); }
            if (ctr > 10) { setState(2); return }
        }, 1000);
        return () => clearInterval(interval);
    }, []);

    return <Main>
        {state !== 2 && <StyledSpinner />}
        {state === 1 && <div className="mt-4"><WarnAlert>Verbindung zur API dauert ungewöhnlich lange</WarnAlert></div>}
        {state === 2 && <div className="mt-4"><ErrorAlert>Verbindung zur API fehlgeschlagen</ErrorAlert></div>}
    </Main>
}
export default Loading;